function load(component) {
    return () =>import (`@/components/${component}.vue`);
};
export default {
    path:"setting",
    component:load("setting/layout"),
    children:[
        {
            path:"",
            name:"setting",
            component:load("setting/index"),
            meta: {
                parent: 'system',
                child: 'setting',
                deal: false
            }
        }
    ],
};



// WEBPACK FOOTER //
// ./src/components/setting/route/index.js